import $ from 'jquery';

export default class ActivityService {
    static listActivities(fromDate, toDate, user) {
        const userOption = user === 'All' || !user ? '' : '&u=' + user;
        return $.ajax({
            url: '/rest/activity?f=' + fromDate.format("YYYY-MM-DD") + '&t=' + toDate.format("YYYY-MM-DD") + userOption,
            type: 'get'
        });
    }

    static activitySummary(fromDate, toDate, user) {
        const userOption = user === 'All' || !user ? '' : '&u=' + user;
        return $.ajax({
            url: '/rest/activity/summary?f=' + fromDate.format("YYYY-MM-DD") + '&t=' + toDate.format("YYYY-MM-DD") + userOption,
            type: 'get'
        });
    }
}


// WEBPACK FOOTER //
// ./src/admin/activity-service.js